<section class="dynamic-collapse dynamic-bubble-collapse" *ngIf="latest" (click)="dismiss()">
	<div class="dynamic-collapse-header-info dynamic-bubble-header-info">
		<div class="section-title">
			<div class="label">
				<ng-container [ngSwitch]="latest.type">
					<i class="fa fas fa-info" *ngSwitchCase="1"></i>
					<i class="fa fas fa-exclamation" *ngSwitchCase="2"></i>
					<i class="fa fas fa-times" *ngSwitchCase="3"></i>
					<i class="fa fas fa-check" *ngSwitchDefault></i>
				</ng-container>

			</div>
			<div class="title">{{latest.message}}</div>
		</div>
		<div class="section-info">
			{{latest.additionalInfo}}
		</div>
	</div>
</section>
